import { BriefcaseBusiness, UserMinus } from "lucide-react";
import { Link } from "react-router-dom";

import AppEmptyState from "@/components/ui/AppEmptyState";
import { Button } from "@/components/ui/button";
import { formatPilotageCount } from "@/lib/pilotageUi";

const IntercontratPanel = ({
  rows = [],
  totalCollaborators = 0,
  activeConsultantsCount = 0,
  totalIntercontrat = 0,
}) => (
  <section
    className="min-w-0 rounded-3xl border border-white/10 glass p-6"
    data-testid="pilotage-intercontrat"
  >
    <div className="min-w-0">
      <h2 className="flex items-center gap-2 text-lg font-semibold text-white">
        <UserMinus className="h-5 w-5 text-lenvia-blue" />
        Intercontrat
      </h2>
      <p className="mt-1 text-sm text-slate-400">
        Consultants salariés sous contrat actif sans affectation commerciale, calculés à partir du staffing courant.
      </p>
    </div>

    <div className="mt-5 min-w-0">
      {totalCollaborators === 0 ? (
        <AppEmptyState
          title="Aucun collaborateur"
          description="Ajoutez des collaborateurs pour suivre l'intercontrat."
          className="p-6"
          testId="pilotage-intercontrat-empty"
        />
      ) : (
        <div className="grid min-w-0 gap-4 lg:grid-cols-[220px_minmax(0,1fr)]">
          <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-5">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
              Consultants en intercontrat
            </p>
            <p className="mt-3 text-4xl font-semibold text-white">
              {formatPilotageCount(totalIntercontrat)}
            </p>
            <p className="mt-3 text-sm text-slate-400">
              {formatPilotageCount(activeConsultantsCount)} en mission sur {formatPilotageCount(totalCollaborators)}
            </p>
          </div>

          <div className="min-w-0 rounded-3xl border border-white/10 bg-white/[0.02]">
            {rows.length === 0 ? (
              <div className="flex min-h-40 items-center justify-center px-6 text-center text-sm text-slate-400">
                Aucun consultant en intercontrat pour le moment.
              </div>
            ) : (
              <div className="divide-y divide-white/5">
                {rows.map((row) => (
                  <div
                    key={row.key}
                    className="flex min-w-0 flex-col gap-3 px-5 py-4 md:flex-row md:items-center md:justify-between"
                  >
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <p className="truncate font-semibold text-white" title={row.label}>
                          {row.label}
                        </p>
                        <span
                          className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium border ${
                            row.operational_status === "SANS_MISSION_FREELANCE"
                              ? "bg-sky-500/10 text-sky-300 border-sky-500/20"
                              : "bg-amber-500/10 text-amber-300 border-amber-500/20"
                          }`}
                        >
                          {row.operational_status_label || (row.operational_status === "SANS_MISSION_FREELANCE" ? "Freelance sans mission" : "Intercontrat salarié")}
                        </span>
                      </div>
                      {row.secondary ? (
                        <p className="mt-1 truncate text-sm text-slate-500" title={row.secondary}>
                          {row.secondary}
                        </p>
                      ) : null}
                    </div>

                    <Button
                      asChild
                      size="sm"
                      variant="outline"
                      className="h-8 shrink-0 border-white/10 text-xs text-slate-200"
                    >
                      <Link to="/admin/pilotage/missions">
                        <BriefcaseBusiness className="mr-1.5 h-3.5 w-3.5" />
                        Créer mission
                      </Link>
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  </section>
);

export default IntercontratPanel;
